import React from 'react'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import { Form } from 'react-bootstrap'
import Disclaimer from '../../components/BridgingFinance/Disclaimer'
import { ActiveReport } from '../../components/kyc/KycPopupComponent'
interface BridgeThreeProps {
  setShow: (value: boolean) => void
  setActiveReport: (value: ActiveReport) => void
}

const BridgeThree: React.FC<BridgeThreeProps> = ({
  setShow,
  setActiveReport,
}) => {
  const handleAccept = () => {
    setActiveReport('BRIDGE_THREE')
  }

  return (
    <div>
      <Form.Group className="mb-3" style={{ paddingBottom: '37px' }}>
        <Form.Label className="darkGreyTextHeaders">
          BRIDGING FINANCE
        </Form.Label>
      </Form.Group>
      <div className="greyLine"></div>
      <FooterButtons
        setShow={setShow}
        handleSearch={handleAccept}
        searchChildren={'SUBMIT'}
        searchClose="CANCEL"
      />
      <Disclaimer />
    </div>
  )
}

export default BridgeThree
